import React from "react";
import './competences.css';
import { Link } from "react-router-dom";


import {
  Card, CardImg, CardBody,
  CardTitle, CardSubtitle, Container, Row, Col
} from 'reactstrap';

import logoLit from "../../assets/images/lit.svg";
import logoMtt from "../../assets/images/mtt.svg";
import logoFtp from "../../assets/images/ftp.svg";
import logoChsa from "../../assets/images/chsa.svg";
import logoCnt from "../../assets/images/cnt.svg";

class Competences extends React.Component {

  render() {
    return (
      <Row id="competences">
        <Col md="12">
          <h2 className="text-center m-4 font36 letter-space-6p">Navegue pelas competências</h2>
        </Col>
        <Container className="d-flex justify-content-around flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row mt-5 mb-5">
          <Col className="mb-2">
            <Link to="linguagens">
              <Card className="blue">
                <CardImg top src={logoLit} alt="Logo LIT" />
                <CardBody className="text-light font-weight-bold font20 text-center">
                  <CardTitle>LIT</CardTitle>
                  <CardSubtitle>Linguagens e suas tecnologias</CardSubtitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col className="mb-2">
            <Link to="matematica">
              <Card className="purple">
                <CardImg top src={logoMtt} alt="Logo MTT" />
                <CardBody className="text-light font-weight-bold font20 text-center">
                  <CardTitle className="">MTT</CardTitle>
                  <CardSubtitle>Matemática e suas tecnologias</CardSubtitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col className="mb-2">
            <Link to="/ciencias">
              <Card className="green">
                <CardImg top src={logoCnt} alt="Logo CNT" />
                <CardBody className="text-light font-weight-bold font20 text-center">
                  <CardTitle>CNT</CardTitle>
                  <CardSubtitle>Ciência da Natureza e suas tecnologias</CardSubtitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col className="mb-2">
            <Link to="/ciencias-humanas-e-sociais">
              <Card className="orange">
                <CardImg top src={logoChsa} alt="Logo CHSA" />
                <CardBody className="text-light font-weight-bold font20 text-center">
                  <CardTitle>CHSA</CardTitle>
                  <CardSubtitle>Ciências Humanas e Sociais Aplicadas</CardSubtitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col className="mb-2">
            <Link to="/formacao-tecnica-profissional">
              <Card className="brown">
                <CardImg top src={logoFtp} alt="Logo FTP" />
                <CardBody className="text-light font-weight-bold font20 text-center">
                  <CardTitle>FTP</CardTitle>
                  <CardSubtitle>Formação Técnica e Profissional</CardSubtitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
        </Container>
      </Row>
    );
  }
}

export default Competences;